/**
 * When an element's type is a string, it represents a DOM node with that tag name
 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
 *
 * @param {React.element} Component
 * @return {bool} Whether the component is a DOM Element
 */
export default function isDOMElement(Component) {
  return (typeof Component.type === 'string');
}



// WEBPACK FOOTER //
// ./src/isDOMElement.js